import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Expertise from "./sections/Expertise";
import Executive from "./sections/Executive";
import Accounting from "./sections/Accounting";
import Advisory from "./sections/Advisory";
import Pillars from "./sections/Pillars";
import Impact from "./sections/Impact";
import Testimonials from "./sections/Testimonials";
import Assessment from "./sections/Assessment";
import ScaleStrategyContact from "./sections/ScaleStrategyContact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Executive />
      <Expertise />
      <Accounting />
      <Advisory />
      <Pillars />
      <Impact />
      <Testimonials />
      <Assessment />
      <ScaleStrategyContact />
      <Footer />
    </div>;
}